// Flow B (A/B test) selection. Entering at /b, /b/ or /b/<anything> picks B; the choice lives in
// sessionStorage (per tab, survives the Firebase auth reload) and in Redux (app.variant).
// Never localStorage: that would leak B into later, unrelated visits.
// A build can default to B (care host: REACT_APP_DEFAULT_VARIANT=b in .env.care); /b detection wins anywhere.

export const VARIANT_KEY = 'ydo_variant'
export const B_PATH = /^\/b(\/|$)/ // '/b', '/b/', '/b/anything' — NOT '/basic-info', '/beta'

const buildDefault = () =>
  process.env.REACT_APP_DEFAULT_VARIANT === 'b' ? 'b' : 'a'

export function detectVariant(pathname) {
  return typeof pathname === 'string' && B_PATH.test(pathname) ? 'b' : null
}

export function readVariant() {
  let stored = null
  try {
    stored = window.sessionStorage.getItem(VARIANT_KEY)
  } catch (e) {
    return buildDefault()
  }
  if (stored === 'b') return 'b'
  if (stored === null) return buildDefault()
  return 'a'
}

export function storeVariant(v) {
  try {
    window.sessionStorage.setItem(VARIANT_KEY, v)
  } catch (e) {
    // storage blocked (private mode / in-app browser): Redux still holds the variant for this page load
  }
}
